import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { FiretreeEmblem } from './FiretreeEmblem';
interface PageBannerProps {
  title: string;
  subtitle?: string;
  image: string;
}
export function PageBanner({
  title,
  subtitle,
  image
}: PageBannerProps) {
  return <div className="relative w-full overflow-hidden" style={{
    height: '340px'
  }} data-id="element-158">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url("${image}")`
    }} data-id="element-159" />
      <div className="absolute inset-0 bg-brand-charcoal/60" data-id="element-160" />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal/40 to-transparent" data-id="element-161" />
      <div className="relative h-full flex flex-col items-start justify-center px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-162">
        <AnimatedSection data-id="element-163">
          <FiretreeEmblem className="text-white opacity-40 mb-5" size={22} data-id="element-164" />
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white leading-tight" data-id="element-165">
            {title}
          </h1>
          {subtitle && <p className="text-lg md:text-xl text-white/75 mt-4 max-w-2xl" data-id="element-166">
              {subtitle}
            </p>}
        </AnimatedSection>
      </div>
    </div>;
}